import { render, staticRenderFns } from "./GroupEditor.vue?vue&type=template&id=721e50dd"
import script from "./GroupEditor.vue?vue&type=script&lang=js"
export * from "./GroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports